import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { resetAdminDetailedUser, resetDetailedUser } from 'actions/userActions';
import { getAccountsForUserReset } from 'actions/accountActions';

import './user-detail-modal.scss';
import UserDetailsForm from 'forms/user-details-form/user-details-form';
import UserDeactivateForm from 'forms/user-deactivate-form/user-deactivate-form';
import Env from 'Env';
import CustomerAssignUserAccounts from 'features/users/components/customer-assign-user-accounts/customer-assign-user-accounts';
import ViewPortalAccounts from 'features/users/adminportal/view-portal-accounts/view-portal-accounts';
import AssignPortalAccounts from 'features/users/adminportal/assign-portal-accounts/assign-portal-accounts';
import { Tabs } from '@ampol/design-system';
import TabWrapper from 'components/tab-wrapper/TabWrapper';

/**
 * Describe component here
 * @param props
 */
const UserDetailModal = ({ selectedUser, onClose }) => {
  const dispatch = useDispatch();

  const isAdminPortal = Env.isAdminPortal();

  const canReadWriteRole = useSelector(
    (state: any) => state.userStore.canReadWriteUsers
  );
  const loggedInUser = useSelector(
    (state: any) => state.userStore.loggedInUser
  );

  const canReadWrite =
    isAdminPortal ||
    (selectedUser?.userId !== loggedInUser?.userId &&
      selectedUser?.assignedRoleName !== 'Customer Admin')
      ? canReadWriteRole
      : false;

  useEffect(() => {
    return () => {
      resetDetails();
    };
  }, []);

  const resetDetails = () => {
    if (isAdminPortal) {
      dispatch(resetAdminDetailedUser());
    } else {
      dispatch(resetDetailedUser());
    }
    dispatch(getAccountsForUserReset());
  };

  const tabs = [
    {
      id: 'user-details',
      label: 'User details',
      hasAccess: true,
      children: (
        <TabWrapper>
          <UserDetailsForm
            userState={selectedUser}
            canReadWrite={canReadWrite}
          />
        </TabWrapper>
      ),
    },
    {
      id: 'user-account',
      label: 'Assign accounts',
      hasAccess: !isAdminPortal,
      children: (
        <TabWrapper>
          <CustomerAssignUserAccounts
            userState={selectedUser}
            canReadWrite={canReadWrite}
          />
        </TabWrapper>
      ),
    },
    {
      id: 'admin-view-portal-accounts',
      label: 'View portal accounts',
      hasAccess: isAdminPortal,
      children: (
        <TabWrapper>
          <ViewPortalAccounts userId={selectedUser.userId} onClose={onClose} />
        </TabWrapper>
      ),
    },
    {
      id: 'admin-assign-portal-accounts',
      label: 'Assign portal accounts',
      hasAccess: isAdminPortal,
      children: (
        <TabWrapper>
          <AssignPortalAccounts
            userId={selectedUser.userId}
            onAssign={() => {
              setCurrentTab(tabs.find((tab) => tab.id === 'admin-view-portal-accounts'));
            }}
          />
        </TabWrapper>
      ),
    },
    {
      id: 'deactivate-portal-access',
      label: 'Deactivate portal access',
      hasAccess: loggedInUser?.userId !== selectedUser?.userId && canReadWrite,
      children: (
        <TabWrapper>
          <UserDeactivateForm userState={selectedUser} onClose={onClose} />
        </TabWrapper>
      ),
    },
  ];

  const [currentTab, setCurrentTab] = useState(tabs[0]);

  return (
    <div className="w-full -mt-[35px]">
      <Tabs
        items={tabs}
        currentTab={currentTab}
        onTabSelected={setCurrentTab}
        className="w-full"
        isSticky
      />
    </div>
  );
};

export default UserDetailModal;
